import { render, staticRenderFns } from "./Pos_inventory_detail.vue?vue&type=template&id=06f8b8be&scoped=true&"
import script from "./Pos_inventory_detail.vue?vue&type=script&lang=js&"
export * from "./Pos_inventory_detail.vue?vue&type=script&lang=js&"
import style0 from "./Pos_inventory_detail.vue?vue&type=style&index=0&id=06f8b8be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8b8be",
  null
  
)

export default component.exports